import _sfc_main from "./AuthorizedLayout.vue2.js";
/* empty css                      */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const AuthorizedLayout = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-81c21b40"]]);
export {
  AuthorizedLayout as default
};
//# sourceMappingURL=AuthorizedLayout.vue.js.map
